/** 문제 난이도(쉬운 순). 값은 앱의 난이도 DB 와 같다 (JCG-3917, JCG-4192). */
export const PROBLEM_DIFFICULTIES = ["극하", "하", "중", "상", "극상"] as const;
export type ProblemDifficulty = (typeof PROBLEM_DIFFICULTIES)[number];

export function isProblemDifficulty(value: unknown): value is ProblemDifficulty {
  return typeof value === "string" && (PROBLEM_DIFFICULTIES as readonly string[]).includes(value);
}
